import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import useProductListingPageContext from 'data-hooks/useProductListingPageContext';
import MobileModal from 'components/consumer/MobileModal';
import CtaButton from 'components/essentials/Cta/CtaButton';
import MobileOnly from 'components/consumer/MobileOnly';
import withBrowserOnly from 'components/hoc/withBrowserOnly';
import MobileProductListingFilters from './MobileProductListingFilters';
import ProductListingClearAllFiltersButton from '../../ProductListingClearAllFiltersButton';
const MobileProductListingFiltersModal = t0 => {
  const $ = _c(13);
  const {
    isOpen,
    onClose
  } = t0;
  const {
    activeFilterCount,
    productCount
  } = useProductListingPageContext();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ProductListingClearAllFiltersButton />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = productCount || 0;
  const t3 = productCount === 1 ? "" : "s";
  let t4;
  if ($[1] !== onClose || $[2] !== t2 || $[3] !== t3) {
    t4 = <CtaButton block={true} onClick={onClose}>Done ({t2} result{t3})</CtaButton>;
    $[1] = onClose;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = activeFilterCount > 0 ? `Filters (${activeFilterCount})` : "Filters";
  let t6;
  if ($[5] !== isOpen) {
    t6 = isOpen && <MobileProductListingFilters />;
    $[5] = isOpen;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== isOpen || $[8] !== onClose || $[9] !== t4 || $[10] !== t5 || $[11] !== t6) {
    t7 = <MobileOnly><div className="md:hidden"><MobileModal enableHashHistory={false} headerRight={t1} isFullHeight={true} isOpen={isOpen} onClose={onClose} stickyFooter={t4} title={t5}>{t6}</MobileModal></div></MobileOnly>;
    $[7] = isOpen;
    $[8] = onClose;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
};
MobileProductListingFiltersModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func
};
export default withBrowserOnly(MobileProductListingFiltersModal);